import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/happycoins_won.svg';

export default function ModalsHeaderHappycoinsWon() {

  return (
    <div>
      <div className="ModalsHeader blue">
        <div>
          <ModalIcon/>
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
